import React from 'react';
import Modal from 'react-bootstrap4-modal';
import { Link } from 'react-router-dom';
import LocalizedStrings from 'react-localization';

// import { PrintDetails } from './Print-Details';
import localStorage from '../../Common/LocalStorage';
import { translations } from '../../Common/Translations';
import { RoutePaths } from '../../Common/ClientRoutes';
import Slider from '../../Common/components/Slider';
import Images from "../../Common/Images";
import {ImageRotation} from "../../Common/DefaultStyle";
import { calculateRotation } from "../../Common/Helpers";

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang') !== undefined ? localStorage.getFromStorage('lang') : 'en');

class SinglePatientDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      patientDetails: {},
      modalInsuranceCards: false,
      insurancesArray: [],
      primaryFrontStyle: ImageRotation,
      primaryBackStyle: ImageRotation,
      secondaryFrontStyle: ImageRotation,
      secondaryBackStyle: ImageRotation,
      token: localStorage.getToken('token')
    }
  }
  
  componentDidMount() {
    if (this.props.insuranceCards) {
      let insuranceCards = {
        ...this.props.insuranceCards,
        primaryCardNumber: this.props.insuranceCards.primaryCardNumber ? this.props.insuranceCards.primaryCardNumber : 'Not set yet',
        secondaryCardNumber: this.props.insuranceCards.primaryCardNumber ? this.props.insuranceCards.primaryCardNumber : 'Not set yet',
      };
      
      let insurancesArray = this.prepareInsurancesObjects();
      
      this.setState({
        ...this.state,
        patientDetails: {
          ...this.props,
          insuranceCards: insuranceCards
        },
        insurancesArray: insurancesArray
      })
    } else {
      this.setState({
        ...this.state,
        patientDetails: {
          ...this.props
        }
      })
    }
  }
  
  constructImageLink = (image) => {
    return `${image}?access_token=${this.state.token}`;
  };
  
  constructRotationAngle = (degrees) => {
    return `rotate(${degrees}deg)`;
  };
  
  prepareInsurancesObjects = () => {
    let userInsurances = this.props.insuranceCards,
      insurancesArray = [];
    
    if (userInsurances) {
      if (userInsurances.primaryCardNumber && userInsurances.primaryCardImageURL) {
        insurancesArray.push({
          cardNumber: userInsurances.primaryCardNumber,
          cardImage: userInsurances.primaryCardImageURL ? this.constructImageLink(userInsurances.primaryCardImageURL) : Images.UPLOAD_PLACEHOLDER,
          title: 'Primary Insurance Card - Front',
          type: 'primaryFront'
        });
      }
  
      if (userInsurances.primaryCardNumber && userInsurances.primaryCardBackImageURL) {
        insurancesArray.push({
          cardNumber: userInsurances.primaryCardNumber,
          cardImage: userInsurances.primaryCardBackImageURL ? this.constructImageLink(userInsurances.primaryCardBackImageURL) : Images.UPLOAD_PLACEHOLDER,
          title: 'Primary Insurance Card - Back',
          type: 'primaryBack'
        });
      }
  
      if (userInsurances.secondaryCardNumber && userInsurances.secondaryCardImageURL) {
        insurancesArray.push({
          cardNumber: userInsurances.secondaryCardNumber,
          cardImage: userInsurances.secondaryCardImageURL ? this.constructImageLink(userInsurances.secondaryCardImageURL) : Images.UPLOAD_PLACEHOLDER,
          title: 'Secondary Insurance Card - Front',
          type: 'secondaryFront'
        });
      }
  
      if (userInsurances.secondaryCardNumber && userInsurances.secondaryCardBackImageURL) {
        insurancesArray.push({
          cardNumber: userInsurances.secondaryCardNumber,
          cardImage: userInsurances.secondaryCardBackImageURL ? this.constructImageLink(userInsurances.secondaryCardBackImageURL) : Images.UPLOAD_PLACEHOLDER,
          title: 'Secondary Insurance Card - Back',
          type: 'secondaryBack'
        });
      }
    }
    
    return insurancesArray;
  };
  
  generateLines = (title, value) => {
    return (
      <div className="row">
        <div className="col-12 color-dark-gray">{title}</div>
        <div className="col-12 color-light-blue mb-1 qf-big-text">{value}</div>
      </div>
    )
  };
  
  openCardsModal = () => {
    this.setState({
      ...this.state,
      modalInsuranceCards: true
    });
  };
  
  closeCardsModal = () => {
    this.setState({
      ...this.state,
      modalInsuranceCards: false
    });
  };
  
  generateStyle = (type) => {
    return {
      transform: this.constructRotationAngle(this.state[type + 'Style'].rotation),
      maxHeight: this.state[type + 'Style'].height,
      maxWidth: this.state[type + 'Style'].width
    };
  };
  
  rotateImage = (image, direction) => {
    let rotate = this.state[image + 'Style'].rotation;
    
    this.setState({
      ...this.state,
      [image + 'Style']: {
        rotation: calculateRotation(rotate, direction),
        width: `${this[image + 'Holder'].clientHeight}px`,
        height: `${this[image + 'Holder'].clientWidth}px`
      }
    });
  };
  
  generateInsuranceCardSlides = () => {
    return this.state.insurancesArray.map((insurance, index) => {
      return (
        <div key={index} className="col-10 h-100 align-self-center text-center">
          <div className="qf-h-90 text-center" ref={div => (this[insurance.type + 'Holder'] = div)}>
            <span className="qf-helper" />
            <h2>{insurance.title}</h2>
            <div className="qf-slider-img">
              <img src={insurance.cardImage}
                   style={this.generateStyle(insurance.type)}
                   alt={insurance.cardNumber}
                   className="mx-auto"
              />
            </div>
          </div>
          <div className="qf-h-10 qf-insurance-card-info text-center p-2">
            <div>
              <a className="qf-cursor-pointer mr-3"
                 onClick={() => this.rotateImage(insurance.type, 'ccw')}>
                <i className="fa fa-undo" />
              </a>
              <a className="qf-cursor-pointer ml-3"
                 onClick={() => this.rotateImage(insurance.type, 'cw')}>
                <i className="fa fa-undo fa-flip-horizontal" />
              </a>
            </div>
            <div>
              <span>Card Number: {insurance.cardNumber}</span>
            </div>
          </div>
        </div>
      );
    });
  };
  
  render() {
    return (
      <div className="row">
        <div className="col-7">
          {this.generateLines(strings.patient_name, this.props.name)}
          {this.generateLines(strings.Birthday, this.props.dateOfBirth)}
          {this.generateLines(
            strings.patient_insurance_card,
            this.props.insuranceCards && this.props.insuranceCards.primaryCardNumber ? this.props.insuranceCards.primaryCardNumber : 'Not set yet')}
          {this.generateLines(
            strings.patient_insurance_card_2,
            this.props.insuranceCards && this.props.insuranceCards.secondaryCardNumber ? this.props.insuranceCards.secondaryCardNumber : 'Not set yet')}
            
          {this.state.insurancesArray.length !== 0 ? (
            <div className="row">
              <div className="col-12 color-dark-gray">
                {strings.insurance_card_images}
              </div>
              <div className="col-12 color-light-blue mb-1 qf-big-text">
                <a className="qf-cursor-pointer qf-preview-image-link" onClick={this.openCardsModal}>
                  <i>{strings.view_images}</i>
                </a>
              </div>
            </div>
          ) : '' }
          
          <Modal
            visible={this.state.modalInsuranceCards}
            onClickBackdrop={this.closeCardsModal}
            className="qf-image-preview-modal"
            dialogClassName="qf-image-preview-content"
          >
            <div className="modal-body h-100">
              <div className="row h-100 align-items-center">
                <div className='ExampleSliders'>
                  <Slider
                    loop={ false }
                    showArrows={ true}
                    showNav={ false }
                    selected={ 0 }
                  >
                    {this.generateInsuranceCardSlides()}
                  </Slider>
                </div>
              </div>
            </div>
          </Modal>
          
          {this.generateLines(strings.Email, this.props.email)}
          {this.generateLines(strings.phone, this.props.phone)}
          {this.generateLines(strings.address, this.props.address.name)}
          {this.generateLines(strings.Pharmacy, this.props.pharmacy.name)}
          
          <div className="row">
            <div className="col-4 qf-mb-30">
              <Link className="qf-blue-btn" to={RoutePaths.EDIT_PATIENT(this.props.patientId)}>
                {strings.edit_patient}
              </Link>
            </div>
            <div className="col-4 qf-mb-30">
              <div className="qf-delete-btn">
                <h2 className="qf-medium-text color-light-blue text-capitalize" onClick={()=> this.props.openModal('DELETE')}>
                  <i className="fa fa-trash-o mr-2" />
                  {strings.delete_patient}
                </h2>
              </div>
            </div>
            <div className="col-4 qf-mb-30">
              <Link to="#">
                <h2
                  className="qf-medium-text color-light-blue text-capitalize"
                  onClick={() => this.props.openModal('RESEND')}
                >
                  <i className="fa fa-key mr-2" /> {strings.resend_password}
                </h2>
              </Link>
            </div>
          </div>
        
        </div>
        
        {this.props.QRlink !== '' ? (
          <div className="col-5">
            <div className="qf-qr-container" ref={el => (this.componentRef = el)}>
              <div className="qf-qr-title-container mb-1">
                <span className="qf-qr-title color-dark-gray">{strings.generate_QR_code}</span>
              </div>
              <div className="qf-qr-image-container">
                <img className="qf-qr-image" src={this.props.QRlink} alt="" />
              </div>
              <div className="qf-qr-print-container">
                <div className="qf-print-btn">
                  <span className="qf-medium-text color-light-blue">
                    <Link to={RoutePaths.DETAILS_PATIENT_PRINT(this.props.patientId)}>
                      {' '}
                      <i className="fa fa-print mr-2" />
                      {strings.print_QR_code}
                    </Link>
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default SinglePatientDetails;


// WEBPACK FOOTER //
// ./src/customModules/Patients/components/Patient-details.js